import { buildHomeJsonLd } from './homeJsonLd';
import { buildMethodFaqJsonLd } from './methodJsonLd';

/** JSON-LD blocks for public routes (prerender + PublicRouteDocumentMeta). */
export function jsonLdBlocksForRoutePath(path: string): unknown[] | null {
  if (path === '/') {
    return buildHomeJsonLd();
  }
  if (path === '/method') {
    return buildMethodFaqJsonLd();
  }
  return null;
}
